const permissions = {
  header: 'Funções e Permissões',
  notice: 'As alterações afetarão os usuários com funções correspondentes em todos os locais da empresa.',
  toast: {
    delete: 'Função excluída atribuída com sucesso',
    error: 'Algo deu errado',
  },
  actions: {
    save: {
      button: 'Salvar alterações',
      confirmModal: {
        title: 'Confirmação',
        content: 'Tem certeza de que deseja salvar as alterações?',
        confirm: 'Confirmar',
      },
      error: 'Ocorreu um erro ao atualizar as permissões.',
      success: 'Permissões atualizadas com sucesso!',
    },
    search: {
      placeholder: 'Pesquisar...',
    },

    delete: {
      deleteBtn: 'Remover',
    },
    history: {
      historyBtn: 'Histórico',
    },
  },
  roleCard: {
    actions: {
      default: {
        label: 'Padrão',
        title: 'Restaurar as permissões padrão para a função "{{ name }}"',
        text: 'Ao continuar, você reverterá para as permissões de função padrão, resultando na perda de todos os ajustes que você fez.',
        confirm: 'Confirmar',
        success: 'As permissões padrão da função foram restabelecidas com sucesso.',
        failure: 'Não foi possível restaurar as permissões da função devido a um erro inesperado.',
      },
      delete: {
        title: 'Excluir funções',
        deletionEnabled: 'Você está prestes a excluir 1 função',
        deletionDisabled: 'Não é possível excluir função com {{ count }} usuários conectados. Remova os usuários antes de excluir',
      },
    },
    select: {
      all: 'Definir todas as permissões',
      none: 'Desdefinir todas as permissões',
    },
    count: '{{ count }} usuários',
  },
  addRoleCard: {
    title: 'Adicionar +',
    createMode: {
      label: 'Nome:',
    },
  },
  scope: {
    'Holidays': 'Holidays',
    'MissionControl': 'MissionControl',
    'Timeline': 'Timeline',
    'feedbacks': 'Feedbacks',
    'OnlineDrivers': 'Online Drivers',
    'Reservations': 'Booking',
    'LiveMap': 'Live Map',
    'Settings': 'Settings',
    'SettingsTemplates': 'Settings Templates',
    'Vehicles': 'Vehicles',
    'Trips': 'Trips',
    'Suppliers': 'Suppliers',
    'Shuttles': 'Shuttles',
    'Shifts': 'Shifts',
    'Services': 'Services',
    'Roles and Permissions': 'Roles and Permissions',
    'Reports': 'Reports',
    'Rates': 'Rates',
    'Profiles': 'Profiles',
    'Passengers': 'Passengers',
    'Parent': 'Parent',
    'Users': 'Users',
    'Locations': 'Locations',
    'Integrations': 'Integrations',
    'Fares': 'Fares',
    'ExtraServices': 'Extra Services',
    'Drivers': 'Drivers',
    'DriverShifts': 'Driver Shifts',
    'DriverShiftsTemplates': 'Driver Shifts Templates',
    'DataUpload': 'Import',
    'Export': 'Export',
    'CustomRules': 'Custom Rules',
    'BlacklistCards': 'Blacklist Cards',
    'Automations': 'Automations',
    'Attributes': 'Attributes',
    'Areas': 'Areas',
    'ApiKeys': 'API Keys',
    'Caregivers': 'Cuidadores',
  },
  sitesViewError: 'Alternar para uma visualização única de local para acessar esta página',
};

export default permissions;
